import Tilt from "react-parallax-tilt";
import GithubIcon from '../../Assets/social/github-mark.png';
import "./project-cards.scss";

const ProjectCards = ({ name, description, image, demo_link, key_skills, github_link }) => {

  return (
    <div className="parallax-container">
      <Tilt
        className="parallax-effect"
        perspective={500}
        style={{ pointerEvents: "auto" }}
        options={{
          max: 40,
          scale: 1,
          speed: 100,
        }}
      >
        <div className="card" style={{ position: 'relative', zIndex: 10 }}>
          <div className="project-image">
            <img src={image} alt={name} />
          </div>
          <div className="name-desc">
            <h3>{name}</h3>
            <span className="key-skills-heading" style={{ color: "#FCA61F" }}>
              Key Skills:{" "}
              <span className="key-skills-names"
                style={{
                  color: "black",
                  display: "inline-block",
                  maxWidth: "15rem",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  verticalAlign: "bottom",
                }}
              >
                {" "}
                {key_skills}
              </span>
            </span>
          </div>

          <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <a
              className="demo-btn"
              style={{ textDecoration: "none" }}
              href={demo_link}
              target="_blank"
              rel="noreferrer"
            >
              See Demo
            </a>
          </div>

          <div style={{ position: 'absolute', right: '1rem', backgroundColor: '#fff', borderRadius: '50%', top: '1rem', cursor: 'pointer', zIndex: 11, pointerEvents: 'auto' }}>
            <a
              href={github_link}
              target="_blank"
              rel="noreferrer"
            >
              <img src={GithubIcon} alt="" style={{ width: '1.5rem', height: '1.5rem' }} />
            </a>
          </div>
        </div>
      </Tilt>
    </div>
  );
};

export default ProjectCards;
